import React from "react";
import { BulletPointList } from "../components/bullet-point-list.tsx";
import { FontStyles } from "../utils/font-styles.ts";
import { usePropertyDetailsContext } from "./contexts/property-details-context.tsx";

export const KeyFeatures: React.FC = () => {
  const { features } = usePropertyDetailsContext();
  return (
    features && <BulletPointList items={features} as={"h2"} listTitle={"Key features"} headingStyle={FontStyles.h5} />
  );
};
